import { useCallback, useRef, useState } from "react";

// =======================================================
// useHighlight
// -------------------------------------------------------
// Handles appointment and day highlight state.
//
// Responsibilities:
// - Store pending highlight targets
// - Track retry attempts
// - Trigger scroll targets
// - Reset highlight state
//
// DOM access and visual effects remain inside Home.js
// during the first migration step.
// =======================================================

const useHighlight = () => {
  const pendingHighlightRef = useRef({
    dayId: null,
    appointmentId: null,
    appointmentIds: [],
    type: "new",
  });

  const highlightTriesRef = useRef(0);
  const [scrollToTarget, setScrollToTarget] = useState(null);

  // =======================================================
  // Set Pending Highlight
  // -------------------------------------------------------
  // Stores the day and appointment IDs that should be
  // highlighted after the calendar has refreshed.
  // =======================================================

  const setPendingHighlight = useCallback(
    ({
      dayId = null,
      appointmentId = null,
      appointmentIds = [],
      type = "new",
    }) => {
      pendingHighlightRef.current = {
        dayId,
        appointmentId,
        appointmentIds,
        type,
      };
    },
    []
  );

  // =======================================================
  // Reset Pending Highlight
  // -------------------------------------------------------
  // Clears the pending highlight and retry state.
  // =======================================================

  const resetPendingHighlight = useCallback(() => {
    pendingHighlightRef.current = {
      dayId: null,
      appointmentId: null,
      appointmentIds: [],
      type: "new",
    };

    highlightTriesRef.current = 0;
    setScrollToTarget(null);
  }, []);

  return {
    pendingHighlightRef,
    highlightTriesRef,
    scrollToTarget,
    setScrollToTarget,
    setPendingHighlight,
    resetPendingHighlight,
  };
};

export default useHighlight;